import React, { forwardRef, useContext } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import TabsGroupContext from '../TabsGroup/TabsGroupContext'

/* @TODO:
 * - propTypes
 */

const TabPanel = forwardRef(function TabPanel(props, ref) {
	const { children, className, classes, value, ...other } = props

	const TabsGroup = useContext(TabsGroupContext)

	if (TabsGroup === null) {
		throw new TypeError('No TabsGroup provided')
	}
	const id = TabsGroup.getPanelId()
	const tabId = TabsGroup.getTabId()

	return (
		<div
			aria-labelledby={tabId}
			className={clsx('Vb-tab-panel', className)}
			hidden={value !== TabsGroup.value}
			id={id}
			ref={ref}
			role="tabpanel"
			{...other}
		>
			{value === TabsGroup.value && children}
		</div>
	)
})

export default TabPanel

TabPanel.propTypes = {
	/**
	 * The content of the component.
	 */
	children: PropTypes.node,
	/**
	 * Override or extend the styles applied to the component.
	 */
	classes: PropTypes.object,
	/**
	 * @ignore
	 */
	className: PropTypes.string,
	/**
	 * The `value` of the corresponding `Tab`. Must use the index of the `Tab` when
	 * no `value` was passed to `Tab`.
	 */
	value: PropTypes.string.isRequired
}
